import { ref } from 'vue';
import { QTool } from '@/native/plugins/QTool';

const enabled = ref(true);
let listenersInitialized = false;

function setupListeners() {
  if (listenersInitialized) return;
  listenersInitialized = true;

  QTool.addListener('qtoolBluetoothStateChanged', ({ enabled: isEnabled }) => {
    enabled.value = isEnabled;
  });

  QTool.getBluetoothState()
    .then(({ enabled: isEnabled }) => {
      enabled.value = isEnabled;
    })
    .catch(() => {
      // Plugin not available (e.g. web) — leave default.
    });
}

export function useQToolBluetoothState() {
  setupListeners();
  return { enabled };
}
